import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Select } from '@/components/ui/select';

interface Props {
	page: number;
	pageSize: number;
	total: number;
	totalPages: number;
	onPageChange: (page: number) => void;
	onPageSizeChange: (size: number) => void;
}

export function Pagination({ page, pageSize, total, totalPages, onPageChange, onPageSizeChange }: Props) {
	const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
	const end = Math.min(page * pageSize, total);
	return (
		<div className="px-4 md:px-5 py-3 border-t border-line bg-[#fafafa] flex items-center justify-between flex-wrap gap-2.5 text-[16px] text-ink-3">
			<span className="tabular">显示 {start}–{end} / 共 {total} 条</span>
			<div className="flex items-center gap-1.5">
				<span className="text-[15.5px] text-ink-3 hidden sm:inline">每页</span>
				<Select
					value={String(pageSize)}
					onChange={(e) => onPageSizeChange(Number(e.target.value))}
					className="!py-0.5 !text-[15.5px]"
				>
					<option value="10">10</option>
					<option value="20">20</option>
					<option value="50">50</option>
					<option value="100">100</option>
				</Select>
				<button
					onClick={() => onPageChange(page - 1)}
					disabled={page <= 1}
					className="w-7 h-7 rounded-md border border-line bg-white text-ink-2 hover:bg-[#f4f4f3] disabled:opacity-40 disabled:pointer-events-none inline-flex items-center justify-center"
				>
					<ChevronLeft size={14} />
				</button>
				<span className="px-1.5 text-ink-2 tabular">{page} / {totalPages || 1}</span>
				<button
					onClick={() => onPageChange(page + 1)}
					disabled={page >= totalPages}
					className="w-7 h-7 rounded-md border border-line bg-white text-ink-2 hover:bg-[#f4f4f3] disabled:opacity-40 disabled:pointer-events-none inline-flex items-center justify-center"
				>
					<ChevronRight size={14} />
				</button>
			</div>
		</div>
	);
}
